/**
 * Opciones del formulario de alta de clientes nuevos (fase 3 de alta y credenciales).
 * Los tipos y sus campos condicionales los fijó negocio (7-sep-2026).
 */

export const TIPOS_EMPRESA = [
  'Comercial',
  'Distribuidor mayorista',
  'Entidad ganadera',
  'Farmacia',
  'Clínica veterinaria',
  'Veterinario (botiquín)',
  'Tienda / Peluquería',
  'Otros'
];

const REQUIERE_AUTORIZACION = ['Comercial', 'Distribuidor mayorista', 'Entidad ganadera', 'Farmacia'];
const REQUIERE_COLEGIADO = ['Clínica veterinaria', 'Veterinario (botiquín)'];
const REQUIERE_COMUNICACION = ['Tienda / Peluquería'];

/** Qué campo extra exige cada tipo: 'autorizacion' | 'colegiado' | 'comunicacion' | null */
export const campoExtraDe = (tipoEmpresa) => {
  if (REQUIERE_AUTORIZACION.includes(tipoEmpresa)) return 'autorizacion';
  if (REQUIERE_COLEGIADO.includes(tipoEmpresa)) return 'colegiado';
  if (REQUIERE_COMUNICACION.includes(tipoEmpresa)) return 'comunicacion';
  return null;
};

export const PROVINCIAS = [
  'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Barcelona', 'Burgos', 'Cáceres',
  'Cádiz', 'Cantabria', 'Castellón', 'Ceuta', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Girona', 'Granada', 'Guadalajara',
  'Guipúzcoa', 'Huelva', 'Huesca', 'Islas Baleares', 'Jaén', 'La Coruña', 'La Rioja', 'Las Palmas', 'León', 'Lleida',
  'Lugo', 'Madrid', 'Málaga', 'Melilla', 'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Pontevedra', 'Salamanca',
  'Santa Cruz de Tenerife', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia', 'Valladolid',
  'Vizcaya', 'Zamora', 'Zaragoza'
];

/**
 * Validación de NIF / NIE / CIF españoles. En NIF y NIE se comprueba la letra de control; en CIF
 * solo el formato (letra + 7 dígitos + control), porque el dígito de control de algunos CIF
 * antiguos no sigue el algoritmo actual y no queremos rechazar a un cliente real.
 */
export const esDocumentoValido = (valor) => {
  if (!valor) return false;
  const v = valor.toUpperCase().replace(/[\s-]/g, '');
  const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';
  if (/^\d{8}[A-Z]$/.test(v)) {
    return letras[parseInt(v.slice(0, 8), 10) % 23] === v[8];
  }
  if (/^[XYZ]\d{7}[A-Z]$/.test(v)) {
    const num = v.replace('X', '0').replace('Y', '1').replace('Z', '2').slice(0, 8);
    return letras[parseInt(num, 10) % 23] === v[8];
  }
  return /^[ABCDEFGHJKLMNPQRSUVW]\d{7}[0-9A-J]$/.test(v);
};
